import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { Controller, useForm } from 'react-hook-form';
import { getRequiredValidator } from 'validators';
import { Box, ConfirmationModal, TextField, useOverlayContext } from 'seagull';
import { useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { connectControllerToTextField } from '~/utils/react-hook-form.utils';
import CopyAPIKeyModal from './CopyAPIKeyModal';
import styles from './GenerateAPIKeyModal.module.scss';
const GenerateAPIKeyModal = (param)=>{
    let { dismissModal, getIsNameValid, refresh } = param;
    const { t: texts } = useLocaleKeys('pages.apiKeysPage');
    const { t: commonTexts } = useLocaleKeys('common');
    const overlayContext = useOverlayContext();
    const { api } = useStoreActions();
    const ctaText = commonTexts.buttons.generateApiKey();
    const { control, handleSubmit } = useForm({
        mode: 'all',
        defaultValues: {
            apiKeyName: ''
        }
    });
    const onSubmit = handleSubmit(async (param)=>{
        let { apiKeyName } = param;
        const { apiKey } = await api.business.createAPIKey(apiKeyName.trim());
        await refresh();
        dismissModal();
        overlayContext.showModal({
            biName: 'copy_api_key_modal',
            content: (param)=>{
                let { dismissModal: dismissCopyModal } = param;
                return /*#__PURE__*/ _jsx(CopyAPIKeyModal, {
                    dismissModal: dismissCopyModal,
                    apiKeyName: apiKeyName,
                    apiKeyValue: apiKey
                });
            },
            closeOnClickOutside: true,
            closeOnEscapeKey: true
        });
    });
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        bi: {
            primaryButton: {
                name: 'generate_a_p_i_key_confirm'
            },
            secondaryButton: {
                name: 'generate_a_p_i_key_cancel'
            }
        },
        title: ctaText,
        testId: "generate-api-key-modal",
        width: "640px",
        className: styles.generateApiKeyModal,
        content: /*#__PURE__*/ _jsx(Controller, {
            control: control,
            name: "apiKeyName",
            rules: {
                validate: (value)=>{
                    const requiredError = getRequiredValidator('API key name is required')(value);
                    if (requiredError !== true) return requiredError;
                    return getIsNameValid(value) || 'API key name already exists';
                }
            },
            render: (props)=>{
                const _connectControllerToTextField = connectControllerToTextField(props), { error, helperText } = _connectControllerToTextField, rest = _object_without_properties(_connectControllerToTextField, [
                    "error",
                    "helperText"
                ]);
                return /*#__PURE__*/ _jsx(Box, {
                    className: styles.generateApiKeyModalContent,
                    children: /*#__PURE__*/ _jsx(TextField, _object_spread({
                        bi: {
                            name: 'api_key_name'
                        },
                        collapseHelperText: false,
                        label: texts.apiKeyNameLabel(),
                        testId: "api-key-name",
                        autoFocus: true,
                        error: error,
                        helperText: helperText
                    }, rest))
                });
            }
        }),
        primaryButtonLabel: ctaText,
        onPrimaryButtonClick: onSubmit,
        secondaryButtonLabel: commonTexts.buttons.cancel(),
        onSecondaryButtonClick: dismissModal
    });
};
export default GenerateAPIKeyModal;
